import { useLanguage } from "../context/LanguageContext";
import { waLink } from "../lib/spa";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const FloatingWhatsApp = () => {
  const { t } = useLanguage();
  return (
    <a
      data-testid="floating-whatsapp-button"
      href={waLink(t("booking.generalMessage"))}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t("whatsapp.float")}
      className="group fixed bottom-6 right-6 z-40 flex items-center gap-0 overflow-hidden rounded-full bg-[#25D366] p-4 text-white shadow-lg shadow-black/40 transition-all duration-300 hover:scale-105 hover:shadow-xl"
    >
      <WhatsAppIcon className="h-6 w-6" />
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium opacity-0 transition-all duration-500 group-hover:ml-2 group-hover:max-w-xs group-hover:opacity-100">
        {t("whatsapp.float")}
      </span>
    </a>
  );
};
